import alt from 'components/Dispatcher';
import immutableStore from 'alt-utils/lib/ImmutableUtil';
import {Record} from 'immutable';
import FileUploadCallCardActions from 'actions/FileUploadCallCardActions';
import PlaybackActions from 'actions/PlaybackActions';

@immutableStore
class FileUploadCallCardStore {
  constructor() {
    this.state = new Record({
      isScorecardToggled: undefined,
      areScorecardResultsToggled: false,
      // `libraryTagDropdownOpened` is `true` if <LibraryTagCallsSearchDropdown /> is open so that
      // the <FileUploadCallCard /> component stops handling pointer-events which is a workaround for
      // react-select who passes pointer events to components beneath it
      libraryTagDropdownOpened: false,
    })();
    this.bindActions(FileUploadCallCardActions);
  }

  onSetLibraryTagDropdownOpened(opened) {
    const state = this.state.set('libraryTagDropdownOpened', opened);
    this.setState(state);
  }

  toggleScorecard(toggled) {
    this.setState(
      this.state
        .set('isScorecardToggled', toggled)
        .set('areScorecardResultsToggled', toggled ? this.state.areScorecardResultsToggled : false)
    );
    if (toggled) {
      PlaybackActions.dialogMaskShown.defer();
    } else {
      PlaybackActions.dialogMaskHidden.defer();
    }
    // hack to force sticky components to rerender
    // wait for video player to hide itself.. which seems to take a while
    setTimeout(() => window.dispatchEvent(new Event('scroll')), 2000);
  }

  toggleScorecardResults(toggled) {
    this.setState(this.state.set('areScorecardResultsToggled', toggled));
  }
}

export default alt.createStore(FileUploadCallCardStore, 'FileUploadCallCardStore');
